import { Button } from '@components/ui/button';
import { cn } from '@utils/cn';
import { useTranslation } from 'react-i18next';
import { AccountLoadErrorProps } from './types';

export const AccountLoadError = ({ onRetry, onSignInAgain, inline }: AccountLoadErrorProps) => {
  const { t } = useTranslation('app');

  return (
    <div
      role="alert"
      className={cn(
        'flex items-center justify-center text-center',
        inline ? 'gap-3 lg:col-start-2' : 'flex-col gap-2 p-4',
      )}>
      <p className="text-sm font-bold text-neutral-800">
        {t('pages.login.accountLoadError.title')}
      </p>
      {!inline && (
        <p className="max-w-sm text-xs text-neutral-600">
          {t(
            onRetry
              ? 'pages.login.accountLoadError.description'
              : 'pages.login.accountLoadError.sessionDescription',
          )}
        </p>
      )}
      <div className="flex gap-2">
        {onRetry && (
          <Button disabled={false} size="sm" className="w-fit" onClick={onRetry}>
            {t('actions.tryAgain')}
          </Button>
        )}
        <Button
          disabled={false}
          variant={onRetry ? 'secondary' : 'default'}
          size="sm"
          className="w-fit"
          onClick={onSignInAgain}>
          {t('pages.login.accountLoadError.signInAgain')}
        </Button>
      </div>
    </div>
  );
};
